import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';

export type UseAppDispatchReturnType = ThunkDispatch<any, any, Action>;

export default function useAppDispatch() {
  return useDispatch<UseAppDispatchReturnType>();
}
